import { createContext, useContext, useState } from "react";

export const UserContext = createContext();
UserContext.displayName = "User";
export const useUser = () => useContext(UserContext);

const UserProvider = ({ children = null }) => {
    const [userToken, setUserToken] = useState(null);

    return (
        <UserContext.Provider value={{ userToken, setUserToken }}>{children}</UserContext.Provider>
    );
};

export default UserProvider;
